import React, { useEffect, useState } from "react";
import { Row, Col, Pagination, Spinner } from "react-bootstrap";
import BTable from "react-bootstrap/Table";
import { useTable, useSortBy } from "react-table";
import { Navigate, useNavigate } from "react-router-dom";
import { left, right } from "../../assets/img";
import { useAppContext } from "../../Services/AppContext";
import { MaskIcon } from "../MaskIcon";


export function Table({
  columns,
  data = [],
  loading = false,
  setPageno,
  pagecount = 0,
  totalPages,
  show,
  tableHeight,
  tableMargin,
  pageno,
  totalWithdraw,
  showWithdrawTotal = false,
  color = "#000",
}) {
  const [pagenumber, setPagenumber] = useState(1);
  const { arrowEnable } = useAppContext();
  const navigate = useNavigate();
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows, // use rows instead of page for external pagination
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      manualPagination: true, // 👈 external pagination
      pageCount: totalPages,
      initialState: { pageIndex: pageno ? pageno - 1 : 0 },
    },
    useSortBy
  );

  useEffect(() => {
    setPagenumber(pageIndex + 1);
  }, [pageIndex]);

  useEffect(() => {
    //     console.log("saideBarShow in Table:", arrowEnable);
  }, [arrowEnable]);
  return (
    <div
      className="table-design tablealign position-relative"
      style={{
        // height: tableHeight || '100%',
        marginBottom: tableMargin ? tableMargin : 130,
        paddingBottom: 30,
        overflowY: tableHeight === 'auto' ? 'visible' : 'auto',
        // border: "1.5px solid #bcbcbc",  // Added full border around the table container
      }}
    >
      <BTable
        size="sm"
        responsive
        {...getTableProps()}
        className="table-border table mb-0"
        style={{ border: "1px solid #bcbcbc", borderCollapse: "separate", borderSpacing: 0 }}
      >
        <thead className="fixed-header">
          {headerGroups.map((headerGroup, ind) => (
            <tr className="thfiled" {...headerGroup.getHeaderGroupProps()} key={ind}>
              {headerGroup.headers.map((column, indx) => (
                <th
                  className="px-2 text-center"
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  key={indx}
                  style={{
                    verticalAlign: "middle",
                    borderBottom: "1.5px solid #bcbcbc",
                    borderRight: "2px solid #d9d9d9",
                    backgroundClip: "padding-box",
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                  }}
                >
                  <h4 style={{ fontSize: 15, color: '#8F0D3d' }} className="f3 fs-xs-14 fs-md-15 py-2 word-per-line">
                    {column.render("Header")}
                  </h4>
                  <span>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <span className="feather icon-arrow-down text-muted float-right" />
                      ) : (
                        <span className="feather icon-arrow-up text-muted float-right" />
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {/* 🌀 Show loading */}
          {loading ? (
            <tr style={{ backgroundColor: '#f0ede6' }}>
              <td style={{ backgroundColor: '#f0ede6' }} colSpan={columns.length} className="text-center py-5">
                <Spinner animation="border" size="sm" /> &nbsp; Loading data...
              </td>
            </tr>
          ) : rows.length > 0 ? (
            rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr className="text-start f2" {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, ind) => {
                    const isClickable = [
                      "id",
                      "client_id",
                      "name",
                      "mobile",
                      "related_client_mobile",
                      "client_mobile",
                    ].includes(cell.column.id);

                    return (
                      <td
                        style={{
                          borderTop: "1px solid #bcbcbc",
                          borderLeft: "none",
                          // borderBottom: "1px solid #bcbcbc", // added row bottom border for row lines
                          color: color,
                          cursor: isClickable ? "pointer" : "default",
                          // borderRight: "2px solid #bcbcbc",
                          verticalAlign: "middle"
                          
                        }}
                        className="f3 fs-xs-14 fs-md-14 gray2 list-data"
                        {...cell.getCellProps()}
                        key={ind}
                        onClick={() => {
                          if (cell.column.Header === " To Phone No") Navigate("/client-report", { state: { type: "edit", data: { client_id: row.original?.related_client_id } } });
                          else if (isClickable) navigate("/client-report", { state: { type: "edit", data: row.original } });
                        }}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            // ❌ No data found
            <tr style={{ backgroundColor: '#f0ede6' }}>
              <td colSpan={columns.length} className="text-center f3 py-5 text-muted">
                No data found
              </td>
            </tr>
          )}
        </tbody>
      </BTable>

      {/* 🔢 Pagination */}
      {show && (
        <Row
  style={{ zIndex: 999, width: !arrowEnable ? "101.5%" : "" }}
  className="justify-content-between table-show p-1 bg-primary2"
>
  <Col className="w-100">

    {/* Total Withdraw */}
   {showWithdrawTotal && (
   <div style={{
          position: 'fixed',
          bottom: 100,
          background: "#F0EDE6",
          width: "100%",
          justifyContent: "center",
          padding: "10px 0",
          marginBottom: 2,
          right: 0
        }} className="col-md-5 w-100 d-flex totoAmmut">
          <div className="total_amount">
            <h4 className="f4 text-center  fs-xs-15 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17" >
              Total Withdraw amount: ₹ {totalWithdraw}
            </h4>
          </div>
        </div>)}

    {/* Pagination */}
    <div className="d-flex ac-jb pagination_box">
      <p className="px-1 mb-0 f3 fs-xs-13 fs-md-14">
        Total Pages: <strong>{pagecount}</strong>
      </p>

      <Pagination className="gap-1 pointer mb-0 d-flex ac-js align-items-center">

        {pageno > 1 && (
          <MaskIcon
            src={left}
            width={18}
            alt="Previous"
            onClick={() => {
              if (pageno > 1) setPageno(pageno - 1);
            }}
            style={{ cursor: "pointer" }}
          />
        )}

        <input
          type="number"
          value={pageno === "" ? "" : pageno}
          onFocus={(e) => e.target.select()}
          onChange={(e) => {
            const value = e.target.value;

            if (value === "") {
              setPageno("");
              return;
            }

            const num = Number(value);

            if (!isNaN(num)) {
              const clamped = Math.max(1, Math.min(pagecount, num));
              setPageno(clamped);
            }
          }}
          onBlur={() => {
            if (pageno === "") {
              setPageno(1);
            }
          }}
          style={{
            width: "28px",
            minWidth: "28px",
            height: "26px",
            borderRadius: "8px",
            border: "2px solid #8F0D3d",
          }}
          className="form-control text-center p-0 placholdercolorchanges2"
        />

        {pageno < pagecount && (
          <MaskIcon
            src={right}
            width={18}
            alt="Next"
            onClick={() => {
              if (pageno < pagecount) setPageno(pageno + 1);
            }}
            style={{ cursor: "pointer" }}
          />
        )}
      </Pagination>
    </div>

  </Col>
</Row>
      )}
    </div>
  );
}
